<template>
  <AnnotationImages :images="imageData" :project="this.projectId" @open-bottom-sheet="openBottomSheet" />
</template>
<script>
import { IOVThesholds } from '../../../../helpers/iovthresholds'
import AnnotationImages from './AnnotationImages.vue'
// import BottomSheet from './BottomSheet.vue'
import { mapState, mapActions } from 'vuex'
import { apiRoute } from './../../../../helpers/api-route'

export default {
  props: {
    projectId: null
  },
  components: {
    AnnotationImages
    // BottomSheet
  },

  computed: {
    ...mapState('labelledImagesSubmission', {
      images: (state) => state
    }),
    ...mapState('usersSubmission', ['members', 'loading']),
    loadFetch () {
      return this.images.loading
    },
    loadMem () {
      return this.loading
    },
    readers () {
      if (this.members && this.members.length > 0 && this.projectId) {
        const _project = this.projectId._id
        const _readers = []
        this.members.forEach(_member => {
          const _role = _member.projectRole.find(_role => _role.project === _project)
          if (_role && _role.role === 'Reader') {
            _readers.push(_member)
          }
        })

        return _readers
      } else {
        return []
      }
    },
    moderators () {
      if (this.members && this.members.length > 0 && this.projectId) {
        const _project = this.projectId._id
        const _readers = []
        this.members.forEach(_member => {
          const _role = _member.projectRole.find(_role => _role.project === _project)
          if (_role && _role.role === 'Moderator') {
            _readers.push(_member)
          }
        })

        return _readers
      } else {
        return []
      }
    }
  },
  data () {
    return {
      selectedUser: null,
      selectedImage: null,
      bottomSheetOpen: false,
      imageData: [],
      filter: '',
      filterPath: '',
      search: ''
    }
  },

  methods: {
    ...mapActions('labelledImagesSubmission', ['fetchLabelledImages2']),
    searchImages (term) {
      this.search = term
      var searchFilter = this.images.labelledImages.filter(img => img.image.image.name.includes(term))
      this.imageData = this.transformImageData(searchFilter, false)
      // this.imageData = this.transformImageData(this.images.labelledImages, true, name)
    },
    filterImages (name) {
      // // // console.log(name)
      if (this.search === '') {
        this.imageData = this.transformImageData(this.images.labelledImages, true, name)
      } else {
        var searchFilter = this.images.labelledImages.filter(img => img.image.image.name.includes(this.search))
        this.imageData = this.transformImageData(searchFilter, true, name)
      }
    },
    filterImagesPath (name) {
      // // console.log(name)
      // if (this.search === '') {
      //   this.imageData = this.transformImageData(this.images.labelledImages, true, name)
      // } else {
      //   var searchFilter = this.images.labelledImages.filter(img => img.image.image.name.includes(this.search))
      //   this.imageData = this.transformImageData(searchFilter, true, name)
      // }
    },
    transformImageData (data, filterFlag, filtername) {
      if (!data) {
        return []
      }
      const transformedData = []
      if (!filterFlag || filtername === 'All' || filtername === '') {
        for (const item of data) {
          // if (item.image && item.image.image && item.image.image.path && !item.image.removed.find(p => p.project === this.projectId._id)) {
          const readerCount = item.users.filter(u => u.role === 'Reader').length
          const modFlag = item.users.filter(u => u.role === 'Moderator').length > 0
          console.log('readercount', readerCount)
          transformedData.push({
            id: item.imageId,
            url: apiRoute() + '/image/' + item.imageId,
            details: {
              created: item.created_at,
              format: item.image.contentType,
              imgName: item.image.name,
              meta: item.metadata,
              iou: item.accuracy,
              pathologies: new Set(item.pathologies),
              tags: new Set(item.tags),
              diagnoses: new Set(item.diagnoses),
              image_set: item.image_set && item.image_set.name ? item.image_set : null,
              otherImages: item.otherImages
            },
            style: modFlag ? 'purple' : (this.readers.length === 1 && readerCount === 1) || (readerCount === this.readers.length && item.accuracy < IOVThesholds().fullAgreement) ? 'green' : (readerCount === this.readers.length && item.accuracy >= IOVThesholds().partialAgreement ? 'red' : 'orange'),
            fullyAnnotated: readerCount === this.readers.length
          })
          // }
        }
      }

      return transformedData
    },
    openBottomSheet (image) {
      try {
        this.$emit('open-bottom-sheet', image)
      } catch (error) {
        console.error('Error fetching labelled images:', error)
      }
    },

    closeBottomSheet () {
      this.bottomSheetOpen = false
    }
  },
  watch: {
    loadFetch (_new) {
      if (!_new && !this.loading) {
        this.imageData = this.transformImageData(this.images.labelledImages, false)
      }
    },
    loadMem (_new) {
      if (!_new && !this.images.loading) {
        this.imageData = this.transformImageData(this.images.labelledImages, false)
      }
    }
  },
  mounted () {
    this.imageData = this.transformImageData(this.images.labelledImages, false)
  }
}
</script>
